import MyButton from "@/components/Button";
import { Row } from "@/styles/layout";
import { RiDeleteBack2Fill, RiSave2Fill } from "react-icons/ri";

interface Props {
  onSave: () => void;
  onReset: () => void;
  disabled: boolean;
}
const BrandingControl = ({ onSave, onReset, disabled }: Props) => (
  <Row gridArea="footer" justifyContent={"flex-end"}>
    <MyButton
      disabled={disabled}
      variant="outline"
      onClick={onReset}
      label="Reset"
      containerStyle={{
        height: 32,
        borderRadius: "4px",
        minWidth: "none",
        px: 32,
        mr: 16,
      }}
      labelStyle={{ fontSize: "14px" }}
      Icon={RiDeleteBack2Fill}
    />
    <MyButton
      disabled={disabled}
      variant="primary"
      onClick={onSave}
      label="Save"
      containerStyle={{
        height: 32,
        borderRadius: "4px",
        minWidth: "none",
        px: 32,
      }}
      labelStyle={{ fontSize: "14px" }}
      Icon={RiSave2Fill}
    />
  </Row>
);

export default BrandingControl;
